import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import OrderService from "../../services/OrderService";
import {
  componentKey,
  setCloseOrderDialog,
  setOrderListData,
} from "./orderSlice";

export const { getOrderList, updateOrderStatus } = {
  getOrderList: (payload) => {
    return {
      type: "ORDER/GET_ORDER_LIST",
      payload,
    };
  },
  updateOrderStatus: (payload) => {
    return {
      type: "ORDER/UPDATE_ORDER_STATUS",
      payload,
    };
  },
};

// GET TASK DATA ASYNC
function* getOrderListAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield OrderService.getOrderList(action?.payload);
    const { status } = response;
    if (status) {
      yield put(setOrderListData(response?.data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setOrderListData({}));
    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// UPDATE ORDER STATUS API CALL FUNCTION
function* updateOrderStatusAsync(action) {
  const { payload, id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield OrderService.updateOrderStatus(id, payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setCloseOrderDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseOrderDialog(false));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(getOrderList().type, getOrderListAsync)]);
  yield all([takeLatest(updateOrderStatus().type, updateOrderStatusAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
